import { Report } from 'assets/images';
import { SUBSCRIPTION_MESSAGE_TYPE } from 'util/config/constant';
import {
  MAPPING_ICON_CLASSNAME_BY_NOTIFICATION_SEVERITY,
  MAPPING_NOTIFICATION_ICON_BY_NOTIFICATION_TYPE
} from './constant';

export const getIcon = (type, data) => {
  if (type === SUBSCRIPTION_MESSAGE_TYPE.CLEANING_REPORT) {
    return <Report />;
  }

  if (type === SUBSCRIPTION_MESSAGE_TYPE.NOTIFICATION) {
    const Icon = MAPPING_NOTIFICATION_ICON_BY_NOTIFICATION_TYPE[data.type];

    if (Icon) {
      const className =
        MAPPING_ICON_CLASSNAME_BY_NOTIFICATION_SEVERITY[data.severity];

      return <Icon className={className} />;
    }
  }

  return <></>;
};
